import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface PostscriptThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const PostscriptThreadView = memo(function PostscriptThreadView({
  supportTicketId,
  thread,
}: PostscriptThreadViewProps) {
  return (
    <ChatThreadView
      channel="postscript"
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
